import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api, fmtEUR } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle2, XCircle } from "lucide-react";

export function ZahlungErfolg() {
  const [sp] = useSearchParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    const sid = sp.get("session_id");
    if (!sid) { setErr("Session-ID fehlt."); return; }
    api.get("/public/zahlung/erfolg", { params: { session_id: sid } })
      .then((r) => setData(r.data)).catch((e) => setErr(e?.response?.data?.detail || "Fehler"));
  }, [sp]);
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50" data-testid="zahlung-erfolg-page">
      <Card className="max-w-lg w-full border-emerald-200">
        <CardContent className="p-10 text-center space-y-4">
          <CheckCircle2 className="w-16 h-16 mx-auto text-emerald-600" />
          <h1 className="text-2xl font-bold text-slate-900">Vielen Dank!</h1>
          {err && <p className="text-sm text-rose-600">{err}</p>}
          {data?.order && (
            <>
              <p className="text-sm text-slate-600">Ihre Zahlung für Auftrag <b className="font-mono">{data.order.auftragsnummer}</b> wurde erfolgreich verbucht.</p>
              <p className="text-lg font-semibold" data-testid="zahlung-betrag">{fmtEUR(data.order.summe_brutto)}</p>
              <p className="text-xs text-slate-500">Wir gehen jetzt in die Produktion und melden uns wieder, sobald Ihr Auftrag versandbereit ist.</p>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}

export function ZahlungAbgebrochen() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50" data-testid="zahlung-abgebrochen-page">
      <Card className="max-w-lg w-full border-slate-200">
        <CardContent className="p-10 text-center space-y-4">
          <XCircle className="w-16 h-16 mx-auto text-slate-400" />
          <h1 className="text-2xl font-bold text-slate-900">Zahlung abgebrochen</h1>
          <p className="text-sm text-slate-600">Ihre Zahlung wurde nicht abgeschlossen. Sie können den Zahlungslink jederzeit erneut über die Angebots-E-Mail öffnen.</p>
        </CardContent>
      </Card>
    </div>
  );
}
